// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__30edw","actions":"GroupTable_actions__2gM4y","deleteModalFooter":"GroupTable_deleteModalFooter__356zv"};